import React from "react";
import "../styles/About.css";

function About() {
  return (
    <section className="about">

      <div className="about-container">

        {/* HEADER */}
        <div className="about-header fade-up">
          <h1>Who We Are</h1>
          <p>
            Archon Engineers is a dynamic and forward-thinking company
            specializing in mechanical and civil QA/QC, safety services,
            and advanced engineering solutions.
          </p>
        </div>

        {/* CONTENT SPLIT */}
        <div className="about-content">

          <div className="about-text fade-up delay1">
            <p>
              With an unwavering commitment to quality and precision, we
              ensure compliance with the highest industry standards,
              delivering reliable and effective results across every project.
            </p>

            <p>
              Our expertise spans advanced manufacturing technologies,
              including CNC machining and 3D printing, enabling us to provide
              innovative and customized engineering solutions.
            </p>
          </div>

          <div className="about-highlight fade-up delay2">
            <h3>What Makes Us Different</h3>
            <ul>
              <li>✔ Industry-standard QA/QC practices</li>
              <li>✔ Skilled and experienced engineers</li>
              <li>✔ Advanced manufacturing technologies</li>
              <li>✔ Strong focus on safety & compliance</li>
            </ul>
          </div>

        </div>

        {/* VISION & MISSION */}
        <div className="vision-mission">

          <div className="vm-card fade-up delay3">
            <h2>Our Vision</h2>
            <p>
              To become a leading engineering solutions provider by
              delivering innovative, reliable, and sustainable services.
            </p>
          </div>

          <div className="vm-card fade-up delay4">
            <h2>Our Mission</h2>
            <p>
              To provide high-quality engineering services through
              advanced technology, expertise, and a strong commitment to safety.
            </p>
          </div>

        </div>

      </div>

    </section>
  );
}

export default About;